import { Table, TableContainer, Paper } from "@mui/material";
import { useState, useEffect } from "react";

import DocumentsTableBody from ".././Table/DocumentsTableBody";
import DocumentsTableHead from ".././Table/DocumentsTableHead";
import LoadingIndicator from "../../../../global/LoadingIndicator";
import ResponseModal from "../../../../global/ResponseModal";
import HNSColors from "../../../../ui library/HNSColors";
import { useViewDocumentsPermissions } from "../../hooks/useViewDocumentsPermissions";
import TableActionsMenu from "../TableActionsMenu";

export default function DocumentsTable({
  updateSelectedDocs,
  documents,
  onDocumentUpdate,
  isDocumentsPage,
  hasDocuments,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const { canChangeDocument, canDeleteDocument, canAddAssociation } = useViewDocumentsPermissions();

  const enableThreeDotMenu = canChangeDocument || canDeleteDocument;

  const [documentsList, setDocumentsList] = useState(
    documents?.map((doc) => ({ ...doc, selected: false }))
  );
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setDocumentsList(documents?.map((doc) => ({ ...doc, selected: false })));
  }, [documents]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleUploadSuccess = () => {
    setUploadSuccess(false);
    onDocumentUpdate();
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 3,
        boxShadow: "none",
        maxHeight: "calc(100vh - 23rem)",
        overflow: "auto",
        mt: 3,
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: HNSColors.primary[500],
        },
      }}
    >
      <Table stickyHeader>
        <DocumentsTableHead
          documentsList={documentsList}
          setDocumentsList={setDocumentsList}
          updateSelectedDocs={updateSelectedDocs}
          enableThreeDotMenu={enableThreeDotMenu}
          canAddAssociation={canAddAssociation}
          isDocumentsPage={isDocumentsPage}
          hasDocuments={hasDocuments}
        />
        <DocumentsTableBody
          documents={documents}
          documentsList={documentsList}
          setDocumentsList={setDocumentsList}
          updateSelectedDocs={updateSelectedDocs}
          setAnchorEl={setAnchorEl}
          setSelectedDoc={setSelectedDoc}
          setIsLoading={setIsLoading}
          setUploadSuccess={setUploadSuccess}
          setUploadFailed={setUploadFailed}
          setErrorArray={setErrorArray}
          enableThreeDotMenu={enableThreeDotMenu}
          canAddAssociation={canAddAssociation}
          onDocumentUpdate={onDocumentUpdate}
          isDocumentsPage={isDocumentsPage}
          hasDocuments={hasDocuments}
        />
      </Table>
      <TableActionsMenu
        anchorEl={anchorEl}
        handleClose={handleMenuClose}
        selectedDoc={selectedDoc}
        onDocumentUpdate={onDocumentUpdate}
        setSelectedDoc={setSelectedDoc}
      />
      <LoadingIndicator isLoading={isLoading} />
      <ResponseModal
        title="Update Success"
        description="The image/document was successfully updated"
        openBool={uploadSuccess}
        setOpenBool={setUploadSuccess}
        handleCloseFunc={handleUploadSuccess}
      />
      <ResponseModal
        title="Update failed"
        isError={true}
        openBool={uploadFailed}
        setOpenBool={setUploadFailed}
        errorMessage={errorArray}
      />
    </TableContainer>
  );
}
